module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/03-36ac19ccbe5ad1091416466bdc036c55.jpg";